import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { scroller } from "./components/Scroller";
import UserAgent from "./components/UserAgent";
import ViewPort from "./components/viewport";

export default function () {
  gsap.registerPlugin(ScrollTrigger);
  ViewPort.init();
  new UserAgent();

  //hamburger

  const hamburger = document.querySelector(".hamburger");
  const header = document.querySelector(".header");
  const dataPage = document.querySelector("[data-page]");

  let isMenuOpen = false;

  const preventScroll = (e) => {
    e.stopPropagation();
  };

  hamburger.addEventListener("click", () => {
    hamburger.classList.toggle("is-active");
    header.classList.toggle("is-active");
    dataPage.classList.toggle("is-active");

    if (!isMenuOpen) {
      header.addEventListener("wheel", preventScroll, { passive: false });
      isMenuOpen = true;
    } else {
      header.removeEventListener("wheel", preventScroll);
      isMenuOpen = false;
    }
  });
  //hamburger　ここまで

  // 横リサイズの場合 scrolltriggerリフレッシュ
  let prevWidth = window.innerWidth;
  window.addEventListener("resize", () => {
    if (window.innerWidth !== prevWidth) {
      ScrollTrigger.refresh();
      prevWidth = window.innerWidth;
    }
  });
  // 横リサイズの場合 scrolltriggerリフレッシュ ここまで

  // scrollの定番アニメーション
  const scrollEls = document.querySelectorAll("[data-scroll]");
  document.querySelectorAll('[data-scroll="first"]').forEach((el) => {
    el.classList.add("is-enter");
  });

  scroller.setScroll((e) => {
    // 「first」以外だけをスクロール連動で処理
    scrollEls.forEach((el) => {
      if (el.dataset.scroll === "first") return;

      ScrollTrigger.create({
        trigger: el,
        start: "top 70%",
        onEnter: () => {
          el.classList.add("is-enter");
        },
        once: true,
      });
    });
  });
  // scrollの定番アニメーション ここまで
}

//side

ScrollTrigger.create({
  trigger: ".mv",
  start: "bottom top",
  onEnter: () => document.querySelector(".side").classList.add("is-active"),
  onLeaveBack: () =>
    document.querySelector(".side").classList.remove("is-active"),
});

ScrollTrigger.create({
  trigger: ".footer",
  start: "top bottom",
  end: "bottom bottom",
  onEnter: () => document.querySelector(".side").classList.remove("is-active"),
  onLeaveBack: () => document.querySelector(".side").classList.add("is-active"),
});

//sideここまで

const easeInOutCubic = (t) =>
  t < 0.5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2;

/**
 * @param {number} toY 目標Y座標
 * @param {number} durationMs アニメ時間(ms)
 */
function animateScrollTo(toY, durationMs = 800) {
  const fromY = window.pageYOffset;
  const diff = toY - fromY;
  if (Math.abs(diff) < 2) return;

  const start = performance.now();

  const step = (now) => {
    const elapsed = now - start;
    const t = Math.min(1, elapsed / durationMs);
    const eased = easeInOutCubic(t);

    window.scrollTo(0, fromY + diff * eased);

    if (t < 1) requestAnimationFrame(step);
  };

  requestAnimationFrame(step);
}

document.addEventListener("click", (e) => {
  const a = e.target.closest('a[href^="#"]');
  if (!a) return;

  const hash = a.getAttribute("href");
  if (!hash || hash === "#" || hash === "#!") return;

  const target = document.querySelector(hash);
  if (!target) return;

  // URLに # を付けない
  e.preventDefault();

  // クリック時にヘッダー高を取得（セレクタは適宜）
  const header = document.querySelector("header");
  const headerH = header ? header.getBoundingClientRect().height : 0;

  const targetY =
    target.getBoundingClientRect().top + window.pageYOffset - headerH;

  // ここで好みの長さに（例: 1000ms）
  animateScrollTo(targetY, 1000);

  // 任意: アクセシビリティ（URLは変えずにフォーカスだけ）
  target.setAttribute("tabindex", "-1");
  target.focus({ preventScroll: true });
});
